export default __webpack_public_path__ + "static/pubertad@2x-2d1c8b3501b046b3921d5add2fbe2151.png";